import { Pinia, Store } from 'pinia-class-component';
import { initClient } from '../../api';
import { PqtMeasurementSpecificationTemplate, PqtMeasurementSpecificationTemplatesUiV2Client } from '../../components/backend/backendapi';

@Store({
  id: 'MeasurementSpecificationTemplatesStore',
  name: 'MeasurementSpecificationTemplatesStore',
})
export default class MeasurementSpecificationTemplatesStore extends Pinia {
  private readonly api = initClient(PqtMeasurementSpecificationTemplatesUiV2Client);

  //data
  private _loadingPromise: Promise<PqtMeasurementSpecificationTemplate[]> | null = null;
  private _templates: PqtMeasurementSpecificationTemplate[] = [];

  //getter
  get loading(): boolean {
    return this._loadingPromise !== null;
  }

  get templates(): PqtMeasurementSpecificationTemplate[] {
    return this._templates;
  }

  get templatesById(): Map<string, PqtMeasurementSpecificationTemplate> {
    return new Map(this._templates.map(e => [e.id, e]));
  }

  //actions
  clear(): void {
    this._templates.splice(0);
  }

  setTemplates(templates: PqtMeasurementSpecificationTemplate[]): void {
    this._templates.splice(0);
    this._templates.push(...templates);
  }

  rememberTemplate(template: PqtMeasurementSpecificationTemplate): void {
    const index = this._templates.findIndex(e => e.id === template.id);
    if (index >= 0) {
      this._templates.splice(index, 1, template);
    } else {
      this._templates.push(template);
    }
  }

  forgetTemplate(template: PqtMeasurementSpecificationTemplate): void {
    const index = this._templates.findIndex(e => e.id === template.id);
    if (index >= 0) {
      this._templates.splice(index, 1);
    }
  }

  async reload(force: boolean = false): Promise<void> {
    if (this._loadingPromise) {
      await this._loadingPromise;
      if (!force) {// when force is true, wait for the current operation to complete, then reload
        return;
      }
    }

    try {
      this._loadingPromise = this.api.list();
      const templates = await this._loadingPromise;
      this.setTemplates(templates ?? []);
    } catch (err) {
      this.clear();
    } finally {
      this._loadingPromise = null;
    }
  }

  async loadIfAbsent(): Promise<void> {
    if (this._templates.length > 0) {
      return;
    }
    return await this.reload();
  }
}